import React from 'react';
import classNames from 'classnames';

import bind from '../../bind';
import CoreLink from '../../components/core_link';
import { IDynamicComponentProps } from '../dynamic_component_props';

export interface LinkData {
  text: string;
  url: string;
  isParent?: boolean;
}

export interface IProps extends IDynamicComponentProps {
  links: LinkData[];
  title?: string | JSX.Element;
  backLinkText?: string;
  backLinkUrl?: string;
  jumplinkSlug?: string;
}

export default class LinkList extends React.Component<IProps, null> {
  @bind
  renderLink(link, idx) {
    const classes = classNames(
      'link-list__item',
      { 'link-list__item--parent': link.isParent },
    );

    return (
      <li
        key={`${idx}`}
        className={classes}
      >
        <CoreLink
          to={link.url}
        >
          {link.text}
        </CoreLink>
      </li>
    );
  }

  renderBackLink() {
    if (!this.props.backLinkText || !this.props.backLinkUrl) return null;

    return (
      <li
        className="link-list__item link-list__item--back"
        id={this.props.jumplinkSlug || null}
      >
        <CoreLink
          to={this.props.backLinkUrl}
        >
          {this.props.backLinkText}
        </CoreLink>
      </li>
    );
  }

  render() {
    if (!this.props.links) return null;

    return (
      <nav className="link-list">
        {this.props.title &&
          <h2 className="link-list__title">
            {this.props.title}
          </h2>
        }
        {this.renderBackLink()}
        <ul>
          {this.props.links.map(this.renderLink)}
        </ul>
      </nav>
    );
  }
}
